import React, { Component } from "react";
import { connect } from "react-redux";

import {
  setCurrentPage,
  setCurrentCategory,
  outSideClick,
} from "../actions/siteActions";

import Pages from "./Pages";

class Catalog extends Component {
  productsOnPage = () => {
    const { site } = this.props;
    if (
      site &&
      site.current &&
      site.current.page >= 1 &&
      site.current.category.count >= 5
    ) {
      /*console.log(
        "productsOnPage : ",
        10,
        site.current.page,
        site.current.category.count
      );*/
      return 10;
    } else {
      /*console.log(
        "productsOnPage : ",
        5,
        site.current.page,
        site.current.category.count
      );*/

      return 5;
    }
  };

  getLastPage = (direction) => {
    const { site } = this.props;
    let currentCat = 0;
    let currentCatCount = 0;
    Object.keys(site.categories).map((cat, i) => {
      if (site.categories[cat].id === site.current.category.id) {
        let iDirection =
          Object.keys(site.categories).length < i + direction
            ? i + direction
            : i + direction < 0
            ? Object.keys(site.categories).length - 1
            : i + direction;
        currentCat = site.categories[iDirection];
        currentCatCount = site.categories[iDirection].count;
      }
    });
    if (currentCat <= 5) {
      return 0;
    } else {
      return Math.ceil((currentCatCount - 5) / 10);
    }
  };

  changePage = (direction) => {
    const { site } = this.props;
    if (direction === 1) {
      if (
        site.current.category.count >
        site.current.page * this.productsOnPage() + 5
      ) {
        this.props.setCurrentPage(site.current.page + direction);
      } else {
        this.changeCategory(direction);
        this.props.setCurrentPage(0);
      }
    } else {
      if (site.current.page > 0) {
        this.props.setCurrentPage(site.current.page + direction);
      } else {
        this.changeCategory(direction);
        this.props.setCurrentPage(this.getLastPage(direction)); //get last page
      }
    }
  };

  changeCategory = (direction = 1) => {
    const { site } = this.props;
    Object.keys(site.categories).map((cat, i) => {
      if (site.categories[cat].id === site.current.category.id) {
        if (site.categories.length - 1 <= i) {
          if (direction === 1) {
            this.props.setCurrentCategory(site.categories[0]);
          } else {
            this.props.setCurrentCategory(site.categories[i + direction]);

            if (site.categories[i + direction].count > this.productsOnPage()) {
              this.props.setCurrentPage(
                Math.floor(
                  (site.current.category.count + 10) / this.productsOnPage()
                )
              );
            }
          }
        } else if (i <= 0) {
          if (direction === 1) {
            this.props.setCurrentCategory(site.categories[i + direction]);
          } else {
            this.props.setCurrentCategory(
              site.categories[site.categories.length - 1]
            );
          }
        } else {
          this.props.setCurrentCategory(site.categories[i + direction]);

          if (direction !== 1) {
            if (site.categories[i + direction].count > this.productsOnPage()) {
              this.props.setCurrentPage(
                site.categories[i + direction].count < 15 &&
                  site.categories[i + direction].count > 5
                  ? 1
                  : Math.floor(
                      (site.categories[i + direction].count -
                        this.productsOnPage()) /
                        this.productsOnPage()
                    )
              );
            }
          }
        }
      }
    });
    //  console.log("after---", site.current.category.id);
  };

  onCatalogClick = () => {
    this.props.outSideClick(this.props.site.menu.open);
  };

  swipeDirection = () => {
    if (this.props.swipeDirection === 1) {
      return "swipedLeft";
    } else if (this.props.swipeDirection === -1) {
      return "swipedRight";
    } else {
      return "";
    }
  };

  render() {
    const { site } = this.props;

    return (
      <div
        className={`catalog ${this.swipeDirection()}`}
        onClick={() => this.onCatalogClick()}
        style={{
          backgroundImage:
            "url(" + process.env.PUBLIC_URL + "/img/riidetaust.jpg)",
        }}
      >
        <div className="arrows">
          <button className="left" onClick={() => this.changePage(-1)}>
            <img
              src={process.env.PUBLIC_URL + "/img/arrow_shadow.png"}
              className="arrowShadowImage"
              alt="arrowLeftShadow"
            />
            <img
              src={process.env.PUBLIC_URL + "/img/arrow.png"}
              className="arrowImage"
              alt="arrowLeft"
            />
          </button>
          <button className="right" onClick={() => this.changePage(1)}>
            <img
              src={process.env.PUBLIC_URL + "/img/arrow_shadow.png"}
              className="arrowShadowImage"
              alt="arrowRightShadow"
            />
            <img
              src={process.env.PUBLIC_URL + "/img/arrow.png"}
              className="arrowImage"
              alt="arrowRight"
            />
          </button>
        </div>
        <div className="inside">
          {site.current && site.current.category && <Pages />}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  site: state.site,
});

export default connect(mapStateToProps, {
  setCurrentPage,
  setCurrentCategory,
  outSideClick,
})(Catalog);
